(function ($) {
	$(document).ready(function () {
		// CART SHIPPING AJAX
		function error_ship_ajax(msg) {
			var $input_cep = $(".zipcode-input"),
				$input_container = $(".cart-drawer__footer__row"),
				$erro_ship = $(".erro-shipping");

			$input_cep.val("");
			$input_container.addClass("error-input");

			if (msg.length > 0) {
				$erro_ship.html(msg);
			}
			setTimeout(function () {
				$input_container.removeClass("error-input");
				$erro_ship.html("");
			}, 4000);
		}

		function shipping_ajax() {
			var $input_cep = $(".zipcode-input"),
				$shipping_list = $(".shipping_options__list"),
				$shipping_list_container = $(".cart-drawer__footer__shipping_options"),
				$display_shipping = $(".shipping-display__wrapper"),
				$ship_name_display = $(".shipping-rate-name"),
				$container_ship_name = $(".shipping-rate-name");

			var $cep = $input_cep.val().replace(/\D/g, "");
			var $validacep = /^[0-9]{8}$/;

			console.log($validacep.test($cep));
			if ($cep == "") {
				error_ship_ajax("Campo cep está vazio");
				return;
			}

			if (!$validacep.test($cep)) {
				error_ship_ajax("Cep inválido");
				return;
			}

			$.getJSON(
				"https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
				function (dados) {
					if ("erro" in dados) {
						console.log("Erro na consulta, confira o cep e tente novamente");
						return;
					}

					switch (dados.uf) {
						case "AC":
							dados.uf = "Acre";
							break;
						case "AL":
							dados.uf = "Alagoas";
							break;
						case "AP":
							dados.uf = "Amapa";
							break;
						case "AM":
							dados.uf = "Amazonas";
							break;
						case "BA":
							dados.uf = "Bahia";
							break;
						case "CE":
							dados.uf = "Ceara";
							break;
						case "DF":
							dados.uf = "Distrito Federal";
							break;
						case "ES":
							dados.uf = "Espirito Santo";
							break;
						case "GO":
							dados.uf = "Goias";
							break;
						case "MA":
							dados.uf = "Maranhao";
							break;
						case "MT":
							dados.uf = "Mato Grosso";
							break;
						case "MS":
							dados.uf = "Mato Grosso do Sul";
							break;
						case "MG":
							dados.uf = "Minas Gerais";
							break;
						case "PA":
							dados.uf = "Para";
							break;
						case "PB":
							dados.uf = "Paraiba";
							break;
						case "PR":
							dados.uf = "Parana";
							break;
						case "PE":
							dados.uf = "Pernambuco";
							break;
						case "PI":
							dados.uf = "Piaui";
							break;
						case "RJ":
							dados.uf = "Rio de Janeiro";
							break;
						case "RN":
							dados.uf = "Rio Grande do Norte";
							break;
						case "RS":
							dados.uf = "Rio Grande do Sul";
							break;
						case "RO":
							dados.uf = "Rondonia";
							break;
						case "RR":
							dados.uf = "Roraima";
							break;
						case "SC":
							dados.uf = "Santa Catarina";
							break;
						case "SP":
							dados.uf = "Sao Paulo";
							break;
						case "SE":
							dados.uf = "Sergipe";
							break;
						case "TO":
							dados.uf = "Tocantins";
							break;
					}

					$.ajax({
						type: "GET", //rest Type
						dataType: "json", //mispelled
						url:
							"/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
							$cep +
							"&shipping_address%5Bcountry%5D=" +
							"Brazil" +
							"&shipping_address%5Bprovince%5D=" +
							dados.uf,
						beforeSend: function () {
							$(".overlay-carregando").show();
						},
						success: function (msg) {
							$(".overlay-carregando").hide();
							$shipping_list.html("");
							for (i = 0; i < msg.shipping_rates.length; i++) {
								let $formatedPrice;
								let $estimateShip;
								if (msg.shipping_rates[i].price === 0.0) {
									$formatedPrice = "Grátis";
								} else {
									$formatedPrice = Shopify.formatMoney(
										msg.shipping_rates[i].price,
										window.money_format
									);
								}
								var $priceShip = msg.shipping_rates[i].price;
								if (
									msg.shipping_rates[i].delivery_days[1] == null ||
									msg.shipping_rates[i].delivery_days[1] === 0
								) {
									$estimateShip = "";
								} else {
									$estimateShip =
										"( Em até " +
										msg.shipping_rates[i].delivery_days[1] +
										" dias úteis )";
								}

								var $template =
									'<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
									msg.shipping_rates[i].name
										.toLowerCase()
										.replace(/[^a-z0-9]+/g, "-")
										.replace(/-$/, "")
										.replace(/^-/, "") +
									'" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
									msg.shipping_rates[i].name
										.toLowerCase()
										.replace(/[^a-z0-9]+/g, "-")
										.replace(/-$/, "")
										.replace(/^-/, "") +
									'" data-name="' +
									msg.shipping_rates[i].name +
									'" data-price="' +
									msg.shipping_rates[i].price +
									'" data-formatted-price="' +
									$formatedPrice +
									'" data-delivery="' +
									$estimateShip +
									'"> <span class="check"></span> <span class="text">' +
									msg.shipping_rates[i].name +
									" - " +
									$formatedPrice +
									" " +
									$estimateShip +
									"</span> </label> </li>";

								$shipping_list.append($template);
							}
							$shipping_list_container.removeClass("hidden");
						},
						error: function (erro) {
							$(".overlay-carregando").hide();
							console.log(
								"Erro ao consultar os fretes disponíveis, tente novamente"
							);
						},
					});
				}
			);
		}

		function select_ship(selected) {
			var name = selected.data("name"),
				price = selected.data("price"),
				formated_price = selected.data("formatted-price"),
				delivery = selected.data("delivery"),
				total_container = $("[data-cart-total-value]"),
				subtotal_price = $("[data-cart-subtotal]").attr("data-cart-subtotal");

			var $display_shipping = $(".shipping-display__wrapper"),
				$ship_name_display = $(".shipping-rate-name"),
				$ship_price_display = $(".shipping-display.value"),
				$shipping_list_container = $(".cart-drawer__footer__shipping_options"),
				$btn_calc = $(".calculate-shipping"),
				$btn_change = $(".recalculate-shipping");

			var shippingNumbers = price.toString().replaceAll(".", "");
			shippingNumbers = parseInt(shippingNumbers);

			total_container.html(
				Shopify.formatMoney(
					parseInt(subtotal_price) + shippingNumbers,
					window.money_format
				)
			);
			$ship_name_display.html(name);
			$ship_price_display.html(formated_price);

			$display_shipping.removeClass("hidden");
			$ship_name_display.removeClass("hidden");
			$shipping_list_container.addClass("hidden");
			$btn_calc.addClass("hidden");
			$btn_change.removeClass("hidden");
		}

		function show_rate_list() {
			var $shipping_list_container = $(
				".cart-drawer__footer__shipping_options"
			);
			$shipping_list_container.removeClass("hidden");
		}

		function reset_ship() {
			var $shipping_list_container = $(
				".cart-drawer__footer__shipping_options"
			),
				$display_shipping = $(".shipping-display__wrapper"),
				$btn_calc = $(".calculate-shipping"),
				$btn_change = $(".recalculate-shipping"),
				$input_cep = $(".zipcode-input");

			$shipping_list_container.addClass("hidden");
			$display_shipping.addClass("hidden");
			$btn_change.addClass("hidden");
			$btn_calc.removeClass("hidden");
			$input_cep.val("").focus();
		}

		$(document).on("click", ".calculate-shipping", function (e) {
			shipping_ajax();
		});

		$(document).on("click", ".recalculate-shipping", function (e) {
			reset_ship();
		});

		$(document).on("click", "[data-shipping-change]", function (e) {
			select_ship($(this).find("input"));
		});

		$(document).on("click", ".show-rates-list", function (e) {
			show_rate_list();
		});

		$(document).on("click", "[hide-filters]", function (e) {
			$(".background-overlay").trigger("click");
		});

		$(document).on("input", ".zipcode-input", function () {
			if (!$(this).val().length > 0) {
				reset_ship();
			}
		});

		// END CART SHIPPING AJAX CODE
	});

	function copyToClipboard(element) {
		var oldValue = $(element).html();

		navigator.clipboard.writeText(oldValue);

		$(element).html("COPIADO");
		setTimeout(function () {
			$(element).html(oldValue);
		}, 300);
	}

	$(document).on("click", "cupom", function (e) {
		e.preventDefault();
		e.stopPropagation();
		copyToClipboard(this);
	});

	function calculatePrice() {
		let price = 0;
		let priceCompare = 0;

		const complementaryProductsCards = document.querySelectorAll(
			".product-item-bundle.checked"
		);
		complementaryProductsCards.forEach((complementaryProduct) => {
			price = Number(price) + Number(complementaryProduct.dataset.price);
			priceCompare =
				Number(priceCompare) +
				Number(
					Number(complementaryProduct.dataset.CompareAtPrice) == 0
						? complementaryProduct.dataset.price
						: complementaryProduct.dataset.compareAtPrice
				);
		});

		if (price < priceCompare) {
			document.querySelector(
				".bundle-price-total .bundle-price-compare"
			).textContent = Shopify.formatMoney(priceCompare, window.money_format);
		} else {
			document.querySelector(
				".bundle-price-total .bundle-price-compare"
			).textContent = "";
		}
		document.querySelector(".bundle-price-total .bundle-price").textContent =
			Shopify.formatMoney(price, window.money_format);
	}

	$(document).on("change", ".product-item-bundle__checkbox", function (e) {
		e.stopPropagation();
		const target = $(e.target);
		let checkbox = $(this);

		checkbox.closest(".product-item-bundle").toggleClass("checked");
		calculatePrice();
	});

	$(document).on("click", ".add-bundle", function (e) {
		e.preventDefault();
		e.stopPropagation();

		let formData = {
			items: [],
		};
		const complementaryProductsCards = document.querySelectorAll(
			".product-item-bundle.checked"
		);

		complementaryProductsCards.forEach((complementaryProductsCard) => {
			formData.items.push({
				id: complementaryProductsCard.dataset.variant,
				quantity: 1,
			});
		});

		if (formData.items.length > 0) {
			fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			})
				.then((response) => {
					document.body.classList.remove("bundle-sidebar-show");
					Shopify.getCart((cart) => {
						window.updateCart(cart);
					});
					return response.json();
				})
				.catch((error) => {
					console.error("Error:", error);
				});
		}
	});

	if (document.body.classList.contains('template-product')) {
		$(document).on('click', '.ver-conteudo-ingredientes', function (e) {
			const content = document.querySelector('.ingredientes-content')
			if (content.classList.contains("hide-content")) {
				document.querySelector('.ver-conteudo-ingredientes').innerText = "ver menos detalhes"
			} else {
				document.querySelector('.ver-conteudo-ingredientes').innerText = "ver mais detalhes"
			}
			content.classList.toggle('hide-content');
		})
	}

	document.addEventListener('click', function (event) {
		const wrapper = event.target.closest('.card-action__wrapper');

		if (!wrapper) return;

		// Evita disparar duas vezes quando o botão ou link real for clicado.
		if (event.target.closest('button, a, input, select, textarea')) return;

		const action = wrapper.querySelector(
			'[data-btn-addToCart], button[type="submit"], a.button-ATC'
		);

		if (action) {
			action.click();
		}
	});

	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Enter' && event.key !== ' ') return;

		const wrapper = event.target.closest('.card-action__wrapper');

		if (!wrapper) return;

		event.preventDefault();

		const action = wrapper.querySelector(
			'[data-btn-addToCart], button[type="submit"], a.button-ATC'
		);

		if (action) {
			action.click();
		}
	});
})(jQuery);
